import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { smmLoginAdmin, smmLoginClient } from '../../utils/smmApi'
import styles from './SmmLogin.module.css'

export default function SmmLogin() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const mode = params.get('mode') === 'client' ? 'client' : 'admin'

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const fn = mode === 'admin' ? smmLoginAdmin : smmLoginClient
      const { access_token, role } = await fn(password)
      localStorage.setItem('smm_token', access_token)
      localStorage.setItem('smm_role', role)
      navigate('/smm/dashboard')
    } catch {
      setError('Неверный пароль')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>📊</div>
        <h1 className={styles.title}>SMM Dashboard</h1>
        <p className={styles.subtitle}>
          {mode === 'admin' ? 'Вход для администратора' : 'Доступ для клиента'}
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Пароль</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Введите пароль"
              autoFocus
            />
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading || !password}>
            {loading ? <span className="spinner" /> : 'Войти'}
          </button>
        </form>

        {mode === 'admin' && (
          <p className={styles.switchLink}>
            Клиент?{' '}
            <a href="?mode=client">Перейти к клиентскому входу</a>
          </p>
        )}
        {mode === 'client' && (
          <p className={styles.switchLink}>
            Администратор?{' '}
            <a href="?mode=admin">Войти как администратор</a>
          </p>
        )}
      </div>
    </div>
  )
}
